"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var StatsigContext = /** @class */ (function () {
    function StatsigContext(ctx) {
        this.ctx = ctx;
        this.caller = ctx.caller;
        this.eventCount = ctx.eventCount;
        this.configName = ctx.configName;
        this.clientKey = ctx.clientKey;
        this.hash = ctx.clientKey;
        this.bypassDedupe = ctx.bypassDedupe;
        this.targetAppID = ctx.targetAppID;
    }
    StatsigContext["new"] = function (ctx) {
        return new this(ctx);
    };
    // Create a new context to avoid modifying context up the stack
    StatsigContext.prototype.withTargetAppID = function (targetAppID) {
        return StatsigContext["new"](__assign(__assign({}, this.ctx), { targetAppID: targetAppID }));
    };
    StatsigContext.prototype.getContextForLogging = function () {
        return {
            tag: this.caller,
            eventCount: this.eventCount,
            configName: this.configName,
            clientKey: this.clientKey,
            hash: this.clientKey
        };
    };
    return StatsigContext;
}());
exports["default"] = StatsigContext;
